import React, { useState, useEffect } from 'react';
import { useTranslation } from '../../i18n/useTranslation';
import { PORTFOLIO_ITEMS } from '../../constants';
import { getMultiCdnUrl } from '../../utils/imageUtils';

const Portfolio: React.FC = () => {
  const { t } = useTranslation();
  const [searchQuery, setSearchQuery] = useState(() => localStorage.getItem('portfolioSearchQuery') || '');

  useEffect(() => {
    localStorage.setItem('portfolioSearchQuery', searchQuery);
  }, [searchQuery]);

  const filteredItems = PORTFOLIO_ITEMS.filter(item =>
    t(item.titleKey).toLowerCase().includes(searchQuery.toLowerCase()) ||
    t(item.categoryKey).toLowerCase().includes(searchQuery.toLowerCase())
  );

  const isFeatured = (id: string) => {
    // Example logic for featured items, can be adapted
    return ['p-1', 'p-4'].includes(id);
  }

  return (
    <div className="container mx-auto px-6 py-16">
      <div className="text-center mb-12">
        <h2 className="text-4xl md:text-5xl font-serif-display font-bold text-gray-900 dark:text-white">{t('portfolio.title')}</h2>
        <p className="text-gray-600 dark:text-gray-400 mt-2 max-w-2xl mx-auto">{t('portfolio.description')}</p>
        <div className="w-24 h-1 bg-amber-400 mx-auto mt-4"></div>
      </div>

      <div className="mb-8 max-w-lg mx-auto">
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          placeholder={t('portfolio.searchPlaceholder') as string}
          className="w-full bg-white dark:bg-gray-800/50 text-gray-900 dark:text-white border border-gray-300 dark:border-gray-700 rounded-full py-3 px-6 focus:ring-2 focus:ring-amber-400 focus:border-transparent transition"
        />
      </div>

      {filteredItems.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {filteredItems.map((item) => (
            <div key={item.id} className={`group relative overflow-hidden rounded-lg shadow-lg ${isFeatured(item.id) ? 'md:row-span-2' : ''}`}>
              <img
                src={getMultiCdnUrl(item.imageUrl, 'PORTFOLIO')}
                alt={t(item.titleKey)}
                className="w-full h-full object-cover transition-transform duration-500 ease-in-out group-hover:scale-110"
                loading="lazy"
                decoding="async"
              />
              <div className="absolute inset-0 bg-black/70 dark:bg-black/70 opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-end p-6">
                <div>
                  <h3 className="text-white text-xl font-bold font-serif-display">{t(item.titleKey)}</h3>
                  <p className="text-amber-300 text-sm">{t(item.categoryKey)}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-16 text-gray-500 dark:text-gray-400">
          <h3 className="text-2xl font-semibold">{t('portfolio.noResults.title')}</h3>
          <p className="mt-2">{t('portfolio.noResults.message')}</p>
        </div>
      )}
    </div>
  );
};

export default Portfolio;